import React from 'react'
import PropTypes from 'prop-types'
import { observer, PropTypes as MobxPropTypes } from 'mobx-react'
import styled from 'styled-components'

import FontAwesome from 'react-fontawesome'
import Button from 'react-bootstrap/lib/Button'
import Panel from 'react-bootstrap/lib/Panel'
import CheckboxTree from 'react-checkbox-tree'

import 'react-checkbox-tree/lib/react-checkbox-tree.css'

const SpeciesLabel = styled.span`
  font-weight: normal;
  font-size: 14px;
`

function SpeciesFilter({ store, title }) {
  const { speciesFilter } = store
  const { expanded, selected } = speciesFilter

  const counts = speciesFilter.getAllCounts

  function handleClear() {
    speciesFilter.setSelected()
  }

  const nodes = [
    {
      value: 'dmel',
      label: (
        <SpeciesLabel>
          <i>D. melanogaster</i> ({counts.dmel || 0})
        </SpeciesLabel>
      ),
      disabled: !(counts.dmel && counts.dmel > 0),
    },
    {
      value: 'hsap',
      label: (
        <SpeciesLabel>
          <i>H. sapiens</i> (transgenes in flies) ({counts.hsap || 0})
        </SpeciesLabel>
      ),
      disabled: !(counts.hsap && counts.hsap > 0),
    },
    {
      value: 'dros',
      label: (
        <SpeciesLabel>
          other <i>Drosophila</i> species ({counts.dros || 0})
        </SpeciesLabel>
      ),
      disabled: !(counts.dros && counts.dros > 0),
      children: [
        {
          value: 'dsim',
          label: (
            <SpeciesLabel>
              <i>D. simulans</i> ({counts.dsim || 0})
            </SpeciesLabel>
          ),
          disabled: !(counts.dsim && counts.dsim > 0),
        },
        {
          value: 'dsec',
          label: (
            <SpeciesLabel>
              <i>D. sechellia</i> ({counts.dsec || 0})
            </SpeciesLabel>
          ),
          disabled: !(counts.dsec && counts.dsec > 0),
        },
        {
          value: 'dyak',
          label: (
            <SpeciesLabel>
              <i>D. yakuba</i> ({counts.dyak || 0})
            </SpeciesLabel>
          ),
          disabled: !(counts.dyak && counts.dyak > 0),
        },
        {
          value: 'dere',
          label: (
            <SpeciesLabel>
              <i>D. erecta</i> ({counts.dere || 0})
            </SpeciesLabel>
          ),
          disabled: !(counts.dere && counts.dere > 0),
        },
        {
          value: 'dana',
          label: (
            <SpeciesLabel>
              <i>D. ananassae</i> ({counts.dana || 0})
            </SpeciesLabel>
          ),
          disabled: !(counts.dana && counts.dana > 0),
        },
        {
          value: 'dpse',
          label: (
            <SpeciesLabel>
              <i>D. pseudoobscura pseudoobscura</i> ({counts.dpse || 0})
            </SpeciesLabel>
          ),
          disabled: !(counts.dpse && counts.dpse > 0),
        },
        {
          value: 'dper',
          label: (
            <SpeciesLabel>
              <i>D. persimillis</i> ({counts.dper || 0})
            </SpeciesLabel>
          ),
          disabled: !(counts.dper && counts.dper > 0),
        },
        {
          value: 'dwil',
          label: (
            <SpeciesLabel>
              <i>D. willistoni</i> ({counts.dwil || 0})
            </SpeciesLabel>
          ),
          disabled: !(counts.dwil && counts.dwil > 0),
        },
        {
          value: 'dmoj',
          label: (
            <SpeciesLabel>
              <i>D. mojavensis</i> ({counts.dmoj || 0})
            </SpeciesLabel>
          ),
          disabled: !(counts.dmoj && counts.dmoj > 0),
        },
        {
          value: 'dvir',
          label: (
            <SpeciesLabel>
              <i>D. virilis</i> ({counts.dvir || 0})
            </SpeciesLabel>
          ),
          disabled: !(counts.dvir && counts.dvir > 0),
        },
        {
          value: 'dgri',
          label: (
            <SpeciesLabel>
              <i>D. grimshawi</i> ({counts.dgri || 0})
            </SpeciesLabel>
          ),
          disabled: !(counts.dgri && counts.dgri > 0),
        },
        {
          value: 'other_dros',
          label: <SpeciesLabel>Others ({counts.other_dros || 0})</SpeciesLabel>,
          disabled: !(counts.other_dros && counts.other_dros > 0),
        },
      ],
    },
    {
      value: 'other',
      disabled: !(counts.other && counts.other > 0),
      label: <SpeciesLabel>Other species ({counts.other || 0})</SpeciesLabel>,
    },
  ]

  const selectedWithCounts = selected
    .slice()
    .filter((species) => speciesFilter.getCount(species) > 0)

  const fullTitle = (
    <div>
      <b>{title}</b>
      <Button bsStyle="link" className="pull-right" onClick={handleClear}>
        clear
      </Button>
    </div>
  )

  return (
    <Panel header={fullTitle}>
      {speciesFilter.isLoading && (
        <b>
          <FontAwesome name="spinner" spin={true} /> Loading...
        </b>
      )}
      <CheckboxTree
        nodes={nodes}
        checked={selectedWithCounts}
        expanded={expanded.slice()}
        onCheck={speciesFilter.setSelected}
        onExpand={speciesFilter.setExpanded}
        showNodeIcon={false}
        nativeCheckboxes={true}
      />
    </Panel>
  )
}

SpeciesFilter.propTypes = {
  store: MobxPropTypes.observableObject.isRequired,
  title: PropTypes.string,
}

SpeciesFilter.defaultProps = {
  title: 'Filter by species',
}

export default observer(SpeciesFilter)
